/**
 * @desc 单独顺延
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.SinglePostponementRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/singlePostponement`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
